import React, {useState} from 'react';
import {useMutation} from 'react-apollo-hooks';
import gql from 'graphql-tag';

import {useAuth} from 'context';
import {Button, Card, Input, PlainButton, Loading} from 'ui-kit';

import * as styles from './Login.module.css';

export function Login({showSignup}) {
  const {login} = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const mutate = useMutation(gql`
    mutation SignInStaffMember($email: String!, $password: String!) {
      signInStaffMember(email: $email, password: $password) {
        token
        errors {
          message
        }
      }
    }
  `);

  async function handleSubmit(event) {
    event.preventDefault();

    setLoading(true);

    try {
      const {data} = await mutate({
        variables: {email, password},
      });

      setLoading(false);

      const {errors, token} = data.signInStaffMember;

      if (errors.length > 0) {
        setError(true);
      } else {
        login(token);
      }
    } catch (error) {
      // Handle this separately since it is from a server error
      setError(true);
    }
  }

  const errorMarkup = error ? (
    <p className={styles.Error}>
      <small>The email and password provided do not match.</small>
    </p>
  ) : null;

  return (
    <div className={styles.Container}>
      <Card>
        <h1>Log in</h1>

        <p>
          Don't have an account yet?{' '}
          <PlainButton type="button" onClick={showSignup}>
            Sign up
          </PlainButton>
        </p>

        {errorMarkup}

        <form method="post" onSubmit={handleSubmit}>
          <Input
            label="Email"
            name="email"
            value={email}
            onChange={event => setEmail(event.target.value)}
          />

          <Input
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={event => setPassword(event.target.value)}
          />

          <Button type="submit" block disabled={loading}>
            {loading ? <Loading immediate /> : 'Continue'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
